/* eslint-disable import/prefer-default-export */
import React from "react";
import { TableCell } from "carbon-components-react";

import { EMDASH } from "@eave/shared/utils/general";

/*
 * If the value is:
 * - null, undefined, or empty string, return emdash
 * - an object, return the object directly, allowing for super customized <td> cell
 * - otherwise, it's a value, so print the value wrapped in a <td>
 *
 * Optionally, also pass in a `style` object to be applied to the cell
 */
export const prepareTableCell = ({ value, id }, style = {}) => {
  // If null, undefined, or empty string, print sentinel value of "-"
  // (CAUTION: 'typeof null' is equal to 'object' in JS, keep this if statement FIRST to ensure columns work properly)
  if (value === null || value === undefined || value === "") {
    return (
      <TableCell key={id} style={style}>
        {EMDASH}
      </TableCell>
    );
  }

  if (isSortableCellObject(value)) {
    return value.display;
  }

  // If we're passing in a TableCell directly, just render it raw
  if (typeof value === "object" && value.type.displayName === "TableCell") {
    return value;
  }

  // Otherwise, print the cell value as normal
  return (
    <TableCell title={value} key={id} style={style}>
      {value}
    </TableCell>
  );
};

// If the value is an object with a `sortComparisonValue` key,
// it means that we need to display an element, but still provide sorting on that column
export const isSortableCellObject = (value: any): boolean => {
  return typeof value === "object" && value.hasOwnProperty("sortComparisonValue");
};
